import http from '@/utils/http' //引入axios
export const getcharty = data => http.get('/kg-payment/api/charty', {
    params: data
})
export const addcharty = data => http.post('/kg-payment/api/charty', data)
export const updatacharty = data => http.put('/kg-payment/api/charty', data)
export const getchartyTransaction = data => http.get('/kg-payment/api/charity/transaction', {
    params: data
})
export default {
    getcharty,
    addcharty,
    updatacharty,
    getchartyTransaction
}